function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from 'react';

function SmallCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.984.251a.855.855 0 010 1.212L7.447 6l4.537 4.537a.855.855 0 01-.606 1.462.852.852 0 01-.606-.25L6.235 7.212l-4.537 4.537a.852.852 0 01-.605.25.855.855 0 01-.606-1.463L5.023 6 .487 1.463a.855.855 0 010-1.212.855.855 0 011.211 0l4.537 4.537L10.772.251a.855.855 0 011.212 0z",
    fill: "#5C50BB",
    fillRule: "evenodd"
  }));
}

export default SmallCross;